<template>
   <div>
      <el-input
        v-model="searchForm.searchText"
        placeholder="请输入内容"
        @keyup.native.code.13="search"
      >
        <el-select
          slot="prepend"
          v-model="searchForm.searchType"
          class="type-select"
          placeholder="请选择"
          @change="dimensionChange"
        >
          <el-option
            v-for="(item, index) in searhTypeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          slot="append"
          type="primary"
          class="search-button"
          @click="search"
        >
          搜&nbsp;索
        </el-button>
      </el-input>
    </div>
</template>

<script>
export default {
  props: {
    searhTypeOptions: {
      type: Array,
      default () {
        return []
      }
    },
    defaultSearchType: {
      type: String,
      default: 'titleAndMainContent'
    }
  },
  data () {
    return {
      searchForm: {
        searchText: '',
        searchType: this.defaultSearchType
      }
    }
  },
  methods: {
    dimensionChange (val) {
      this.$emit('dimensionChange', val)
    },
    search () {
      // if (!this.searchForm.searchText.replace(/\s/g, '')) {
      //   this.$message({type: 'info', message: '检索条件不能为空！'})
      // } else {
        this.$emit('search', this.searchForm)
        this.searchForm.searchText = ''
      // }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/searchComponent/searchInput.vue